       <!-- Itinerary -->

       <div class="row g-3 mb-3 pb-4 border-bottom">
        <div class="col-md-12">
          <h5 class="card-judul mb-0">Itinerary</h5>
        </div>
      </div>

      <div class="row mb-3 pb-4">
        <div class="col-md-12">         

          <div class="accordion" id="itineraryAccordion">
            <div *ngIf="boatItinerary && boatItinerary.length; else noItineraries">
              <div *ngFor="let item of boatItinerary; let i = index" class="accordion-item">
                <h2 class="accordion-header d-flex justify-content-between" id="heading{{ i }}">
                    <button 
                      class="accordion-button" 
                      type="button" 
                      (click)="toggleAccordion(i)"
                      [class.collapsed]="!isAccordionOpen[i]"
                      [attr.aria-expanded]="isAccordionOpen[i]">
                      {{ item.judul }}
                    </button>     
                  </h2>
                <div 
                  [id]="'collapse' + i" 
                  class="accordion-collapse collapse" 
                  [class.show]="isAccordionOpen[i]"
                  [attr.aria-labelledby]="'heading' + i">
                  <div class="accordion-body">
                    <p style="display: none;"><strong>ID:</strong> {{ item.id }}</p>
                    <div [innerHTML]="item.ket"></div>
                  </div>
                </div>
              </div>
            </div>
            <ng-template #noItineraries>
              <p>No Itinerary available</p>
            </ng-template>
          </div>
          
          
          
        </div>
      </div>



   




